// GameContainer.jsx
import React, { useState, useEffect } from "react";
import { Grid, Button, Typography } from "@material-ui/core";
import QuickScoringMobile from "./QuickScoringMobile";
import ScoreBoard from "./ScoreBoard";
import TeamPanelForm from "./TeamPanelForm";
import GameClock from "./GameClock";
import {
    initGame,
    saveEvent,
    setGameState,
    getGameState,
    fetchGameStateFromFirestore,
    getClockTimestamps,
    syncOfflineEvents,
    calcularTiempoAcumulado,
    generarGameStats
} from "./gameStorage";
import EventViewer from "./EventViewer";
import { useDispatch, useSelector } from "react-redux";
import { saveGameData, listenToGameData, listenToGameEvents } from "../../../data-store/actions/teamgames-actions";
import { useParams } from "react-router-dom";
import BasketballGameDashboard from "./PublicViews/BasketballGameDashboard";

// TODOS
// Reporte general del evento (puntos por atleta, faltas, tiempo en cancha etc)
// en esa vista agregar perfil de anotador y perfil de coach para que el coash registre al equipo
// Link público del juego
// respaldo en local de toda la bitacora



const GameContainer = () => {
    const [currentPeriod, setCurrentPeriod] = useState(1);
    const [gameStats, setGameStats] = useState(false);
    const [openFormTeam, setOpenFormTeam] = useState(null);
    const [initialElapsedTime, setInitialElapsedTime] = useState(0);
    const [elapsedTime, setElapsedTime] = useState(0);


    const gameData = useSelector((state) => state.teamgames.gameData);
    const gameEvents = useSelector((state) => state.teamgames.gameEvents);

    const { gameId } = useParams();

    const dispatch = useDispatch();

    useEffect(() => {
        const unsubscribe = dispatch(listenToGameData(gameId));
        // Limpia el listener al desmontar
        return () => {
            if (typeof unsubscribe === "function") unsubscribe();
        };
    }, [dispatch, gameId]);
    useEffect(() => {
        const unsubscribe = dispatch(listenToGameEvents(gameId));

        return () => {
            if (typeof unsubscribe === "function") unsubscribe();
        };
    }, [dispatch, gameId]);
    useEffect(() => {
        if (gameData && gameData.estado) {
            setGameStats(generarGameStats(gameEvents, gameData));
            setCurrentPeriod(gameStats.currentPeriod);


        }
    }, [gameEvents, gameData]);

    console.log("generarResumenPorEquipo", gameStats);


    useEffect(() => {
        initGame(gameId);
        // syncOfflineEvents();
        // window.addEventListener("online", syncOfflineEvents);

        // const restoreFromState = (state) => {
        //     setCurrentPeriod(state.currentPeriod);
        // };

        // const stored = getGameState();
        // if (stored) {
        //     restoreFromState(stored);
        // } else {
        //     fetchGameStateFromFirestore().then((state) => {
        //         if (state) restoreFromState(state);
        //     });
        // }

        // calcularTiempoAcumulado("1").then(setInitialElapsedTime);

        // return () => window.removeEventListener("online", syncOfflineEvents);
    }, []);



    const handleMobileAction = (team, index, action, number, numberOut) => {

        console.log("handleMobileAction", action, number, numberOut);
        const isTeamA = team === "A";
        const teamPlayers = isTeamA ? Object.values(gameStats.A.players) : Object.values(gameStats.B.players);
        console.log("handleMobileAction", teamPlayers);
        //const player = teamPlayers.filter((a) => a.number === number)[0];

        //console.log("handleMobileAction", player);
        const timeNow = Date.now();

        if (["1", "2", "3"].includes(action)) {
            //player.points += parseInt(action);
            saveEvent({ tipo: "punto", equipo: team, numero: number, cantidad: parseInt(action), cuarto: parseInt(gameStats.currentPeriod), tiempoSegundos: timeNow });
        } else if (["-1", "-2", "-3"].includes(action)) {
            const toSubtract = Math.abs(parseInt(action));
            //player.points = Math.max(0, player.points - toSubtract);
            saveEvent({ tipo: "quitar_punto", equipo: team, numero: number, cantidad: toSubtract, cuarto: parseInt(gameStats.currentPeriod), tiempoSegundos: timeNow });
        } else if (action === "foul") {
            //console.log("handleMobileAction", player)
            saveEvent({ tipo: "falta", equipo: team, numero: number, cuarto: parseInt(gameStats.currentPeriod), tiempoSegundos: timeNow });
        } else if (action === "-foul") {
            saveEvent({ tipo: "quitar_falta", equipo: team, numero: number, cuarto: parseInt(gameStats.currentPeriod), tiempoSegundos: timeNow });
        } else if (action === "violation") {
            //console.log("handleMobileAction", player)
            saveEvent({ tipo: "violation", equipo: team, numero: number, cuarto: parseInt(gameStats.currentPeriod), tiempoSegundos: timeNow });
        } else if (action === "-violation") {
            saveEvent({ tipo: "quitar_violation", equipo: team, numero: number, cuarto: parseInt(gameStats.currentPeriod), tiempoSegundos: timeNow });
        } else if (action === "assist") {
            //console.log("handleMobileAction", player)
            saveEvent({ tipo: "assist", equipo: team, numero: number, cuarto: parseInt(gameStats.currentPeriod), tiempoSegundos: timeNow });
        } else if (action === "-assist") {
            saveEvent({ tipo: "quitar_assist", equipo: team, numero: number, cuarto: parseInt(gameStats.currentPeriod), tiempoSegundos: timeNow });
        } else if (action === "rebound") {
            //console.log("handleMobileAction", player)
            saveEvent({ tipo: "rebound", equipo: team, numero: number, cuarto: parseInt(gameStats.currentPeriod), tiempoSegundos: timeNow });
        } else if (action === "-rebound") {
            saveEvent({ tipo: "quitar_rebound", equipo: team, numero: number, cuarto: parseInt(gameStats.currentPeriod), tiempoSegundos: timeNow });
        } else if (action === "cambio") {
            saveEvent({ tipo: "cambio", equipo: team, numero: number, cuarto: parseInt(gameStats.currentPeriod), tiempoSegundos: timeNow, numberOut: numberOut });
        } else if (action === "cambiosale") {
            saveEvent({ tipo: "cambiosale", equipo: team, numero: number, cuarto: parseInt(gameStats.currentPeriod), tiempoSegundos: timeNow });
        }

        //teamPlayers[index] = player;


    };

    const handleClockStart = (time) => {
        saveEvent({ tipo: "inicio_crono", cuarto: parseInt(gameStats.currentPeriod), tiempoSegundos: time });
    };

    const handleClockPause = (time) => {
        saveEvent({ tipo: "pausa_crono", cuarto: parseInt(gameStats.currentPeriod), tiempoSegundos: time });
    };

    const handleTeamFormSave = (teamKey, data) => {
        console.log("handleTeamFormSave", teamKey, data)
        if (teamKey === "A") {
            dispatch(saveGameData(gameId, { estado: { teamAInfo: data } }))
        } else {
            dispatch(saveGameData(gameId, { estado: { teamBInfo: data } }))
        }
    };

    console.log("gameStats", gameStats)
    return (
        <div style={{ padding: 5 }}>
            {gameData && gameData.estado && gameStats &&
                (<ScoreBoard teamAInfo={gameData.estado.teamAInfo}
                    teamBInfo={gameData.estado.teamBInfo}
                    currentPeriod={gameStats.currentPeriod} gameStats={gameStats}
                    gameData={gameData}
                    gameId={gameId}
                    onSaveConfig={(config) => dispatch(saveGameData(gameId, config))} />


                )

            }

            {gameData && gameData.estado && gameStats && gameStats.A && gameStats.B && (

                <QuickScoringMobile
                    teamA={Object.values(gameStats.A?.players)}
                    teamB={Object.values(gameStats.B?.players)}
                    teamAInfo={gameData?.estado?.teamAInfo}
                    teamBInfo={gameData?.estado?.teamBInfo}
                    onAction={handleMobileAction}
                    openTeamConfig={setOpenFormTeam}
                />

            )}

            {gameData && gameData.estado && (


                <TeamPanelForm
                    open={openFormTeam === "A"}
                    teamKey="A"
                    initialData={gameData.estado.teamAInfo}
                    onClose={() => setOpenFormTeam(null)}
                    onSave={(data) => handleTeamFormSave("A", data)}
                />
            )}

            {gameData && gameData.estado && (

                <TeamPanelForm
                    open={openFormTeam === "B"}
                    teamKey="B"
                    initialData={gameData.estado.teamBInfo}
                    onClose={() => setOpenFormTeam(null)}
                    onSave={(data) => handleTeamFormSave("B", data)}
                />
            )}


            <GameClock
                onPeriodTimeChange={(period) => setCurrentPeriod(period)}
                onPeriodEnd={(p) => console.log("Periodo finalizado", p)}
                currentPeriodProp={gameStats.currentPeriod}
                onStart={handleClockStart}
                onPause={handleClockPause}
                initialElapsedTime={initialElapsedTime}
                callbackElapsedTime={setElapsedTime}
                clock={gameStats.clock}
            />
            {gameData && gameData.estado && (

                <EventViewer gameId={gameId} gameData={gameData} />
            )}

        </div>
    );
};

export default GameContainer;
